import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function humanisePath(pathname: string): string {
  const segment = pathname.split("/").filter(Boolean).at(-1) ?? "service";
  return segment.replaceAll("-", " ").replace(/\b\w/g, (character) => character.toUpperCase());
}

export function RouteFocus() {
  const location = useLocation();
  useEffect(() => {
    let lastHeading: HTMLElement | null = null;
    let lastName = "";
    let frame: number | undefined;
    const update = () => {
      const heading = [...document.querySelectorAll<HTMLElement>("main h1")]
        .find((element) => !element.closest('[hidden], [aria-hidden="true"]')) ?? null;
      const pageName = heading?.textContent?.trim() || humanisePath(location.pathname);
      if (heading === lastHeading && pageName === lastName) return;
      lastHeading = heading;
      lastName = pageName;
      document.title = `${pageName} — UmoCare`;
      if (frame !== undefined) cancelAnimationFrame(frame);
      if (heading) {
        heading.tabIndex = -1;
        frame = requestAnimationFrame(() => {
          if (heading.isConnected && !heading.closest('[hidden], [aria-hidden="true"]')) heading.focus({ preventScroll: false });
        });
      }
    };
    update();
    // Authentication and data loading can replace the page without changing its URL.
    const observer = new MutationObserver(update);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["hidden", "aria-hidden"] });
    return () => { observer.disconnect(); if (frame !== undefined) cancelAnimationFrame(frame); };
  }, [location.pathname]);
  return null;
}
